import { inject } from '@angular/core';
import { type CanDeactivateFn } from '@angular/router';
import { PendingChangesService } from './pending-changes.service';

export const pendingChangesGuard: CanDeactivateFn<unknown> = () =>
  inject(PendingChangesService).confirmDiscard();